module.exports = __webpack_public_path__ + "static/room-block-flat-6-eb89b33853fb264a5fa36873f69c1e9f.svg";